/* ============================================================
   Maison Atelier Premium — product-form.js
   Selezione variante: prezzo, disponibilità, immagine, URL
   ============================================================ */
(function () {
  'use strict';
  var strings = (window.theme && window.theme.strings) || {};
  var utils = (window.theme && window.theme.utils) || {};

  var root = document.querySelector('[data-product-root]');
  if (!root) return;
  var picker = root.querySelector('[data-variant-picker]');
  var dataEl = root.querySelector('[data-product-variants]');

  var variants = [];
  if (dataEl) {
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!Array.isArray(variants)) return;
  }

  var idInput = root.querySelector('[data-variant-id]');
  var priceWrap = root.querySelector('[data-price-wrapper]');
  var availability = root.querySelector('[data-availability]');
  var addButton = root.querySelector('[data-add-button]');
  var addText = root.querySelector('[data-add-text]');
  var gallery = root.querySelector('[data-product-gallery]');
  var stickyPrice = document.querySelector('.sticky-atc__price');
  var stickyAdd = document.querySelector('[data-sticky-add]');
  var drawerChoices = picker ? picker.querySelectorAll('[data-option-value-choice]') : [];
  var isPreorder = root.getAttribute('data-preorder') === 'true';

  function money(cents) { return utils.formatMoney ? utils.formatMoney(cents) : (cents / 100).toFixed(2); }

  function selectedOptions() {
    if (!picker) return [];
    return Array.prototype.map.call(
      picker.querySelectorAll('.variant-option'),
      function (fieldset) {
        var checked = fieldset.querySelector('input[data-option-value]:checked');
        return checked ? checked.value : null;
      }
    );
  }

  function findVariant(opts) {
    return variants.find(function (v) {
      return v.options.every(function (o, i) { return o === opts[i]; });
    });
  }

  function renderPrice(variant) {
    if (!priceWrap) return;
    var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
    var html = '<div class="price' + (onSale ? ' price--on-sale' : '') + (variant.available ? '' : ' price--unavailable') + '">';
    if (onSale) {
      html += '<span class="price__sale">' + money(variant.price) + '</span>';
      html += '<s class="price__compare">' + money(variant.compare_at_price) + '</s>';
    } else {
      html += '<span class="price__current">' + money(variant.price) + '</span>';
    }
    html += '</div>';
    priceWrap.innerHTML = html;
    if (stickyPrice) stickyPrice.innerHTML = html;
  }

  function updateAvailability(variant) {
    if (!availability) return;
    if (!variant) { availability.textContent = strings.selectVariant || ''; return; }
    if (variant.available) {
      availability.classList.remove('product__availability--low');
      availability.textContent = (strings.inStock || 'Disponibile');
    } else {
      availability.textContent = (strings.outOfStock || strings.soldOut || 'Non disponibile');
    }
  }

  function updateButton(variant) {
    if (!addButton) return;
    var unavailable = !variant || !variant.available;
    addButton.setAttribute('data-variant-unavailable', String(unavailable));
    if (!variant) {
      addButton.disabled = true;
      if (addText) addText.textContent = strings.selectVariant || '';
    } else if (variant.available) {
      addButton.disabled = false;
      if (addText) addText.textContent = isPreorder ? (strings.preorder || strings.addToCart || '') : (strings.addToCart || '');
    } else {
      addButton.disabled = true;
      if (addText) addText.textContent = strings.soldOut || '';
    }
    if (stickyAdd) {
      stickyAdd.disabled = unavailable;
      if (addText) stickyAdd.textContent = addText.textContent;
    }
    var form = addButton.closest('form');
    if (form && form.getAttribute('aria-busy') === 'true') addButton.disabled = true;
  }

  function updateImage(variant) {
    if (!gallery || !variant || !variant.featured_media) return;
    var item = gallery.querySelector('[data-media-id="' + variant.featured_media.id + '"]');
    if (!item) return;
    if (gallery.getAttribute('data-style') === 'carousel') {
      item.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    } else {
      var list = gallery.querySelector('.product__media-list');
      if (list) list.prepend(item);
    }
  }

  function updateURL(variant) {
    if (!variant || !window.history.replaceState) return;
    var url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url.toString());
  }

  function updateOptionSummaries() {
    if (!picker) return;
    selectedOptions().forEach(function (value, index) {
      var summary = picker.querySelector('[data-option-summary="' + index + '"]');
      if (summary) summary.textContent = value || '';
    });
  }

  function updateDrawerChoiceStates() {
    if (!picker) return;
    var opts = selectedOptions();
    drawerChoices.forEach(function (choice) {
      var index = parseInt(choice.getAttribute('data-option-index'), 10);
      var selected = choice.getAttribute('data-option-text') === opts[index];
      choice.classList.toggle('is-selected', selected);
      choice.setAttribute('aria-checked', selected ? 'true' : 'false');
    });
  }

  function onChange() {
    var variant = findVariant(selectedOptions());
    if (idInput) {
      idInput.value = variant ? variant.id : '';
      idInput.disabled = !variant;
    }
    updateOptionSummaries();
    updateDrawerChoiceStates();
    renderPriceSafe(variant);
    updateAvailability(variant);
    updateButton(variant);
    updateImage(variant);
    updateURL(variant);
  }

  function renderPriceSafe(variant) { if (variant) renderPrice(variant); }

  if (picker) {
    picker.addEventListener('change', onChange);
    document.addEventListener('click', function (event) {
      var choice = event.target.closest('[data-option-value-choice]');
      if (!choice) return;
      var input = document.getElementById(choice.getAttribute('data-option-input-id'));
      if (!input || !picker.contains(input)) return;
      event.preventDefault();
      var index = choice.getAttribute('data-option-index');
      var text = choice.getAttribute('data-option-text') || choice.textContent.trim();
      var style = choice.getAttribute('data-option-swatch-style');
      var summary = picker.querySelector('[data-option-summary="' + index + '"]');
      var swatch = picker.querySelector('[data-option-swatch="' + index + '"]');
      if (input) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (summary) summary.textContent = text;
      if (swatch && style) swatch.setAttribute('style', style);
      drawerChoices.forEach(function (item) {
        if (item.getAttribute('data-option-index') !== index) return;
        var selected = item === choice;
        item.classList.toggle('is-selected', selected);
        item.setAttribute('aria-checked', selected ? 'true' : 'false');
      });
      window.setTimeout(function () {
        var drawer = choice.closest('.drawer');
        if (drawer && window.theme && window.theme.closePanel) window.theme.closePanel(drawer);
      }, 120);
    });
    updateOptionSummaries();
    updateDrawerChoiceStates();
  }

  /* sticky add → invia il form */
  if (variants.length) updateButton(variants.find(function (variant) { return idInput && String(variant.id) === idInput.value; }));
  if (stickyAdd) {
    if (addButton) stickyAdd.disabled = addButton.disabled;
    stickyAdd.addEventListener('click', function () {
      var form = root.querySelector('form.product-form');
      if (!form || !addButton || addButton.disabled) return;
      if (form.requestSubmit) form.requestSubmit(addButton);
      else addButton.click();
    });
  }
})();
